<template>
  <div class="state-stepper__wrapper">
    <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
    <v-stepper v-model="position" class="transparent">
      <v-stepper-header>
        <template v-for="step in steps">
          <v-stepper-step
            :key="`state-step-${step.position}`"
            :step="step.position"
            :editable="canTransit(step.name)"
            :complete="step.position < position"
          >
            {{ useI18n ? $t(`labels.${step.display}`) : step.display }}
          </v-stepper-step>
          <v-divider v-if="step.position < steps.length" :key="step.position"></v-divider>
        </template>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isEmpty } from 'lodash/lang'
import { BaseForm, FormErrors } from '@argon/app/components'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE } from '../store'

export default {
  name: 'StateStepper',
  extends: BaseForm,
  components: { FormErrors },
  props: {
    boardItem: { type: Object, required: true },
    include: { type: String, required: true },
    readOnly: { type: Boolean, default: false },
    useI18n: { type: Boolean, default: false }
  },
  data: () => ({
    position: null
  }),
  computed: {
    ...mapState(BOARD_NAMESPACE, ['columns', 'transitions', 'stateAttr']),
    proxyURL() {
      return `/boards/${this.boardItem.board_refname}/items/${this.boardItem.entity.id}`
    },
    steps() {
      return this.columns ? this.columns.map((item, idx) => ({ ...item, position: idx + 1 })) : []
    },
    activeStep() {
      return this.steps.find((step) => step.name === this.boardItem[this.stateAttr])
    }
  },
  watch: {
    position: function (newVal, oldVal) {
      this.setState(newVal, oldVal)
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['getBoardItem', 'transit']),
    setState(newVal, oldVal) {
      let step = this.steps.find((step) => step.position === newVal)
      if (!step) {
        return
      }
      let transition = this.transitions.find(
        (t) => t.from_state === this.boardItem[this.stateAttr] && t.to_state === step.name
      )
      if (!transition) {
        return
      }
      this.resetServerErrors()
      this.transit({
        itemId: this.boardItem.entity.id,
        transition: transition.name,
        after_id: null,
        boardRef: this.boardItem.board_refname
      })
        .catch((error) => {
          this.setServerErrors(error)
          this.position = oldVal
        })
        .finally(() => {
          this.getBoardItem({ url: this.proxyURL, include: this.include })
        })
    },
    canTransit(v) {
      if (this.readOnly) return false
      let isValidState = this.transitions.some(
        (t) => t.from_state === this.boardItem[this.stateAttr] && t.to_state === v
      )
      let hasNoErrors = isEmpty(this.boardItem.report.resolutions)
      return isValidState && hasNoErrors
    }
  },
  created() {
    if (this.activeStep) {
      this.position = this.activeStep.position
    }
  }
}
</script>

<style scoped lang="scss">
.state-stepper__wrapper {
  overflow-x: hidden;

  .v-stepper__header {
    height: auto;
  }
}
</style>
